export type StoryChapterRoute =
  | "story-chapter-01"
  | "story-chapter-02"
  | "story-chapter-03"
  | "story-chapter-04"
  | "story-chapter-05"
  | "story-chapter-06";

export type AppRoute =
  | "title"
  | "menu"
  | "solo"
  | "solo-setup"
  | "solo-battle"
  | "story"
  | StoryChapterRoute
  | "story-extra-outer-window"
  | "online"
  | "online-battle"
  | "rules"
  | "cards"
  | "servants"
  | "settings";

const routeByHash: Readonly<Record<string, AppRoute>> = {
  "/title": "title",
  "/menu": "menu",
  "/solo": "solo",
  "/solo/setup": "solo-setup",
  "/solo/battle": "solo-battle",
  "/story": "story",
  "/story/chapter-01": "story-chapter-01",
  "/story/chapter-02": "story-chapter-02",
  "/story/chapter-03": "story-chapter-03",
  "/story/chapter-04": "story-chapter-04",
  "/story/chapter-05": "story-chapter-05",
  "/story/chapter-06": "story-chapter-06",
  "/story/extra-outer-window": "story-extra-outer-window",
  "/online": "online",
  "/online/battle": "online-battle",
  "/rules": "rules",
  "/cards": "cards",
  "/servants": "servants",
  "/settings": "settings",
};

export class AppRouter {
  private listener: ((route: AppRoute) => void) | null = null;

  public start(listener: (route: AppRoute) => void): void {
    this.listener = listener;
    window.addEventListener("hashchange", this.handleHashChange);
    if (!window.location.hash) {
      window.history.replaceState(null, "", "#/title");
    }
    this.emitCurrentRoute();
  }

  public stop(): void {
    window.removeEventListener("hashchange", this.handleHashChange);
    this.listener = null;
  }

  public navigate(route: AppRoute): void {
    const hash = Object.entries(routeByHash).find(([, value]) => value === route)?.[0]
      ?? "/menu";
    window.location.hash = hash;
  }

  private readonly handleHashChange = (): void => {
    this.emitCurrentRoute();
  };

  private emitCurrentRoute(): void {
    const normalized = window.location.hash.replace(/^#/, "") || "/title";
    this.listener?.(routeByHash[normalized] ?? "menu");
  }
}
